import { render, staticRenderFns } from "./PassengerFlowStat.vue?vue&type=template&id=e37540b0&scoped=true&"
import script from "./PassengerFlowStat.vue?vue&type=script&lang=js&"
export * from "./PassengerFlowStat.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlowStat.vue?vue&type=style&index=0&id=e37540b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37540b0",
  null
  
)

export default component.exports